(function () {
  var hideTimer = null;

  function hideUnavailableProducts() {
    var urlParams = new URLSearchParams(window.location.search);
    var selectedSizes = [];

    for (var _ref of urlParams) {
      var key = _ref[0], value = _ref[1];
      if (key.includes('filter.v.option.tamanho')) {
        selectedSizes.push(value.trim().toLowerCase());
      }
    }

    var productCards = document.querySelectorAll('.bls__grid__item');
    var visibleCount = 0;

    productCards.forEach(function (card) {
      var productItem = card.querySelector('[data-available-sizes]');

      if (!productItem) {
        visibleCount++;
        return;
      }

      if (selectedSizes.length === 0) {
        card.style.display = '';
        visibleCount++;
        return;
      }

      var raw = productItem.getAttribute('data-available-sizes') || '';
      var availableSizes = raw.split('|').map(function (s) { return s.trim().toLowerCase(); }).filter(Boolean);
      var hasMatch = availableSizes.some(function (size) { return selectedSizes.includes(size); });

      if (hasMatch) {
        card.style.display = '';
        visibleCount++;
      } else {
        card.style.display = 'none';
      }
    });

    var toolbarAmount = document.querySelector('#toolbar-amount');
    var toolbarProductsCount = document.querySelector('#toolbar-products-count')
    if (toolbarAmount) {
      toolbarAmount.textContent = 'Mostrando ' + visibleCount + ' de' + toolbarProductsCount.textContent;
    }
  }

  function scheduleHide() {
    clearTimeout(hideTimer);
    hideTimer = setTimeout(hideUnavailableProducts, 150);
  }

  // 1. Execução no carregamento e troca de histórico/seção
  document.addEventListener('DOMContentLoaded', hideUnavailableProducts);
  document.addEventListener('shopify:section:load', scheduleHide);
  window.addEventListener('popstate', scheduleHide);

  // 2. Eventos comuns de filtragem AJAX de temas Shopify (Search & Discovery, Boost, Facets, etc.)
  document.addEventListener('facet:updated', scheduleHide);
  document.addEventListener('collection:reloaded', scheduleHide);
  document.addEventListener('page:loaded', scheduleHide);

  // 3. Intercepta Fetch API (Requisições AJAX modernas dos filtros)
  var originalFetch = window.fetch;
  window.fetch = function () {
    return originalFetch.apply(this, arguments).then(function (response) {
      scheduleHide();
      return response;
    });
  };

  // 4. Intercepta XMLHttpRequest (Requisições AJAX legadas)
  var originalXhrSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    this.addEventListener('load', function () {
      scheduleHide();
    });
    return originalXhrSend.apply(this, arguments);
  };

  // 5. Intercepta alterações no PushState / ReplaceState (muda a URL via JS sem recarregar a página)
  var originalPushState = history.pushState;
  history.pushState = function () {
    originalPushState.apply(this, arguments);
    scheduleHide();
  };

  var originalReplaceState = history.replaceState;
  history.replaceState = function () {
    originalReplaceState.apply(this, arguments);
    scheduleHide();
  };

  // 6. MutationObserver para detectar inserção de novos elementos no DOM
  var lastUrl = location.href;
  new MutationObserver(function (mutations) {
    var url = location.href;

    if (url !== lastUrl) {
      lastUrl = url;
      scheduleHide();
      return;
    }

    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var node = added[j];
        if (node.nodeType === 1) {
          if (node.classList && node.classList.contains('bls__grid__item')) {
            scheduleHide();
            return;
          }
          if (node.querySelector && node.querySelector('.bls__grid__item')) {
            scheduleHide();
            return;
          }
        }
      }
    }
  }).observe(document.body || document.documentElement, { subtree: true, childList: true });
})();